<template>
  <div id="app" style="height: 100%;">
    <b-navbar toggleable="md" type="dark" variant="dark">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse id="nav_collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item>
            <router-link tag="li" to="/">Home</router-link>
          </b-nav-item>
          <b-nav-item-dropdown
            v-if="authenticated"
            text="Search"
            extra-toggle-classes="nav-link-custom"
            right
          >
            <b-dropdown-item>
              <router-link tag="li" to="/blast">Blast</router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link tag="li" to="/search">By ids</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item v-if="authenticated">
            <router-link tag="li" to="/jbrowse">JBrowse</router-link>
          </b-nav-item> -->
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown
            v-if="authenticated"
            text="Species set"
            extra-toggle-classes="nav-link-custom"
            right
          >
            <b-dropdown-item>
              <router-link tag="li" to="/user/speciesSet">Species set creation</router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link tag="li" to="/user/removeSets">Remove species sets</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            v-if="authenticated"
            text="User"
            extra-toggle-classes="nav-link-custom"
            right
          >
            <b-dropdown-item-button @click="logout">Logout</b-dropdown-item-button>
            <b-dropdown-item>
              <router-link tag="li" to="/user/changePassword">Change Password</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <template v-else>
            <b-nav-item>
              <router-link tag="li" to="/user/login">Login</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link tag="li" to="/user/forgotPassword">Forgot Password?</router-link>
            </b-nav-item>
          </template>
          <b-nav-item-dropdown
            v-show="isAdmin"
            id="nav7_ddown"
            text="Administration"
            extra-toggle-classes="nav-link-custom"
            right
          >
            <b-dropdown-item>
              <router-link tag="li" to="/admin/assignCategories">Assign categories</router-link>
            </b-dropdown-item>
            <!--<b-dropdown-item>
              <router-link tag="li" to="/admin/user_manager">User manager</router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link tag="li" to="/admin/add_db">Add databaser</router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link tag="li" to="/admin/tree_manager">Tree manager</router-link>
            </b-dropdown-item> -->
          </b-nav-item-dropdown>
          <b-nav-item>
            <router-link tag="li" to="/about">About</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link tag="li" to="/content">SymDB content</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view style="height: 100%;" />

    <b-alert
      dismissible
      :show="dismissCountDown"
      :variant="variant"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
      >{{ messageAlert }}</b-alert
    >
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      messageAlert: '',
      variant: 'success',
    };
  },
  computed: {
    authenticated: function() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin;
    },
  },
  created: function() {
    var token = this.$store.getters.getToken;
    var login = this.$store.getters.getLogin;

    var password = undefined;

    if (token !== undefined && login !== undefined && login !== '') {
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        loader: 'dots',
      });
      this.$store.dispatch('login', { login, password }).then(
        resp => {
          loader.hide();
          if (resp.body.success === true) {
            this.variant = 'success';
            this.messageAlert = 'You have been successfully logged';
            this.showAlert();
          } else {
            this.variant = 'danger';
            this.messageAlert = 'You must be logged to use SymDB';
            this.showAlert();
          }
        },
        () => {
          loader.hide();
          this.variant = 'danger';
          this.messageAlert = 'Problem during connection';
          this.showAlert();
        }
      );
    }
  },
  methods: {
    setAuthenticated(status) {
      this.authenticated = status;
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.variant = 'warning';
        this.messageAlert = 'You have been successfully logged out';
        this.showAlert();
      });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
  },
};
</script>

<style lang="scss">
@import '../node_modules/ag-grid-community/styles/ag-grid.css';
@import '../node_modules/ag-grid-community/styles/ag-theme-balham.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.card {
  padding: 10px !important;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  width: auto;
}

.tooltip .tooltip-inner {
  text-align: left;
  background: white;
  color: steelblue;
  border-radius: 16px;
  border-style: solid;
  border-color: royalblue;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^='top'] {
  margin-bottom: 5px;
}

.tooltip[x-placement^='top'] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='bottom'] {
  margin-top: 5px;
}

.tooltip[x-placement^='bottom'] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='right'] {
  margin-left: 5px;
}

.tooltip[x-placement^='right'] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^='left'] {
  margin-right: 5px;
}

.tooltip[x-placement^='left'] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.color1 rect {
  fill: #5c6d7e;
}

.color2 rect {
  fill: #9b59b6;
}
.color3 rect {
  fill: #5cace2;
}
.color4 rect {
  fill: #57d68d;
}
.color5 rect {
  fill: #c0392b;
}
</style>
